import React, { useId } from "react";
import { Phone } from "lucide-react";
import { WhatsAppIcon, InstagramIcon, FacebookIcon, TelegramIcon, WebchatIcon } from "./iconesCanais";

const ICONES = {
  whatsapp: WhatsAppIcon,
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  telegram: TelegramIcon,
  webchat: WebchatIcon,
};

/**
 * No flutuante de canal. VoIP e um modo de atendimento (nao um canal), entao
 * aparece com estilo proprio e rotulo, em vez do icone colorido de canal.
 */
export function NoCanal({ canal, x, y, tamanho, atraso = 0 }) {
  const Icone = ICONES[canal];
  return (
    <div
      className="absolute"
      style={{ left: x - tamanho / 2, top: y - tamanho / 2, width: tamanho, height: tamanho }}
    >
      <div className="mc-flutuar w-full h-full" style={{ animationDelay: `${atraso}s` }}>
        {canal === "voip" ? (
          <div className="relative w-full h-full">
            <div
              className="w-full h-full rounded-full flex items-center justify-center"
              style={{
                background: "linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.02))",
                border: "1px solid rgba(255,255,255,0.12)",
                boxShadow: "0 12px 30px -8px rgba(0,0,0,0.8), 0 0 24px -6px rgba(34,197,94,0.35)",
              }}
            >
              <Phone className="text-green-400" style={{ width: tamanho * 0.4, height: tamanho * 0.4 }} />
            </div>
            <span
              className="absolute left-1/2 -translate-x-1/2 whitespace-nowrap font-semibold uppercase tracking-wider text-zinc-400"
              style={{ top: tamanho + 8, fontSize: Math.max(10, Math.min(15, tamanho * 0.2)) }}
            >
              VoIP
            </span>
          </div>
        ) : (
          <div
            className="w-full h-full flex items-center justify-center"
            style={{
              borderRadius: Math.max(14, tamanho * 0.28),
              background: "rgba(17,17,17,0.9)",
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0 12px 30px -8px rgba(0,0,0,0.8)",
            }}
          >
            <Icone style={{ width: tamanho * 0.54, height: tamanho * 0.54 }} />
          </div>
        )}
      </div>
    </div>
  );
}

/**
 * Linhas de conexao. Recebem pontos no MESMO sistema de coordenadas do palco
 * (inicio perto do no, fim na borda do mockup/celular), entao sempre se encontram.
 * `curva` = "horizontal" (desktop, lados) ou "vertical" (mobile, de cima).
 */
export function Conexoes({ largura, altura, linhas, curva = "horizontal" }) {
  const uid = useId().replace(/:/g, "");
  return (
    <svg
      className="absolute inset-0 pointer-events-none"
      width={largura}
      height={altura}
      viewBox={`0 0 ${largura} ${altura}`}
    >
      <defs>
        {linhas.map((l, i) => (
          <linearGradient
            key={i}
            id={`mc-linha-${uid}-${i}`}
            gradientUnits="userSpaceOnUse"
            x1={l.de[0]}
            y1={l.de[1]}
            x2={l.ate[0]}
            y2={l.ate[1]}
          >
            <stop offset="0" stopColor="#22c55e" stopOpacity="0.2" />
            <stop offset="1" stopColor="#22c55e" stopOpacity="0.8" />
          </linearGradient>
        ))}
      </defs>
      {linhas.map((l, i) => {
        const [sx, sy] = l.de;
        const [ex, ey] = l.ate;
        const d =
          curva === "vertical"
            ? `M ${sx} ${sy} C ${sx} ${(sy + ey) / 2}, ${ex} ${(sy + ey) / 2}, ${ex} ${ey}`
            : `M ${sx} ${sy} C ${(sx + ex) / 2} ${sy}, ${(sx + ex) / 2} ${ey}, ${ex} ${ey}`;
        return (
          <g key={i}>
            <path
              d={d}
              fill="none"
              stroke={`url(#mc-linha-${uid}-${i})`}
              strokeWidth="1.5"
              strokeDasharray="4 6"
              strokeLinecap="round"
              className="mc-fluxo"
              style={{ animationDelay: `${-i * 0.4}s` }}
            />
            {/* Ponto de chegada na borda do produto */}
            <circle cx={ex} cy={ey} r="9" fill="#22c55e" opacity="0.1" />
            <circle cx={ex} cy={ey} r="2.5" fill="#22c55e" opacity="0.8" />
          </g>
        );
      })}
    </svg>
  );
}
